import { Button } from '@cannect/new-components/atoms/Button'
import { Typography } from '@cannect/new-components/atoms/Typography'
import { LuTrash2, LuX } from 'react-icons/lu'
import { TAppliedFilter } from './helpers'

type TAppliedFiltersSectionProps = {
  filtersCount: number
  appliedFilters: TAppliedFilter[]
  onClearAll: () => void
  onRemoveFilter: (filterKey: TAppliedFilter['key'], value: string) => void
}

export const AppliedFiltersSection = ({
  filtersCount,
  appliedFilters,
  onClearAll,
  onRemoveFilter
}: TAppliedFiltersSectionProps) => {
  if (filtersCount === 0) return null

  return (
    <div className="space-y-3 rounded-lg border border-gray-200 bg-gray-50 p-3">
      <div className="flex items-center justify-between">
        <Typography.Text className="text-sm text-gray-600">Filtros aplicados</Typography.Text>
        <div className="flex items-center gap-2">
          <span className="flex h-5 min-w-5 items-center justify-center rounded-full bg-gray-200 px-1.5 text-xs font-semibold leading-none text-gray-700">
            {filtersCount}
          </span>
          <Button unstyled onClick={onClearAll}>
            <LuTrash2 className="h-4 w-4 text-red-600 hover:text-red-700" />
          </Button>
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        {appliedFilters.map((filter, index) => (
          <div
            key={`${filter.key}-${filter.value}-${index}`}
            className="group flex items-center gap-1 rounded-full bg-primary-600 py-1 pl-3 pr-1 text-sm font-medium text-white shadow-sm transition-all duration-200 hover:scale-105 hover:bg-primary-700 hover:shadow-md">
            <span className="text-xs leading-none">{filter.label}</span>
            <button
              onClick={() => onRemoveFilter(filter.key, filter.value)}
              className="flex h-5 w-5 items-center justify-center rounded-full border-0 bg-primary-600 text-white transition-all duration-200 hover:bg-primary-700"
              aria-label={`Remover filtro ${filter.label}`}>
              <LuX className="h-3 w-3 stroke-[2.5] transition-transform duration-200 group-hover:rotate-90" />
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}
